import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';

import config from './config.json';
window.services = {};

const isAcceptance = process.env.REACT_APP_GUILD_BASE_URL?.includes('guildacceptance.com');

config.services.forEach(({ subdomain }) => {
  const hostIsLocal = process.env.NODE_ENV === 'development';

  const envSubdomain = isAcceptance
    ? hostIsLocal
      ? `${subdomain}-dev`
      : `${subdomain}-staging`
    : subdomain;
  const NAME = snakeCase(subdomain).toUpperCase().replace(/\./, '_');
  const envKey = `REACT_APP_${NAME}_URL`;
  const defaultUrl = `https://${envSubdomain}.${process.env.REACT_APP_GUILD_BASE_URL}`;

  window.services[camelCase(subdomain)] = process.env[envKey] || defaultUrl;
});

import(/* webpackChunkName: "host" */ './index');
